export default "__VITE_ASSET__ARZz9NPy__"